<template>
    <div>
        <div class="OperationBar">
            <el-button type="primary" plain @click="handleClickAddNew">新建</el-button>
        </div>
        <div style="width:100%;">
            <el-table :data="tableData" style="width: 100%">
                
                <el-table-column fixed prop="id" label="用户ID" />
                <el-table-column prop="user_account" label="用户名" />
                <el-table-column prop="user_cnname" label="中文名" />
                <el-table-column prop="user_enname" label="英文名" />
                <el-table-column prop="user_role" label="用户角色"  :formatter="row => { return this.handleUserRole( row ) }"/>
                <el-table-column prop="user_status" label="用户状态" :formatter="row => { return this.handleUserStatus( row ) }" />
                <el-table-column fixed="right" label="操作">
                <template #default="scope">
                    <el-button link type="primary" size="small" @click.prevent="modifyUserRow( scope.row )">编辑</el-button>
                    <el-button link type="primary" size="small" @click.prevent="deleteRow( scope.row )">删除</el-button>
                </template>
                </el-table-column>
            </el-table>
            <el-pagination
                small
                background
                layout="prev, pager, next"
                :total="this.totalRows"
                :page-count="this.totalPage"
                @current-change="hanldeCurrentPage"
                class="mt-4" style="margin: 7px 15px;">
            </el-pagination>
        </div>
        <addUserDialog :isAddUserShow="isAddUserShow" :timekey="timerAdd"/>
        <modifyUserDialog :isModifyUserShow="isModifyUserShow" :currentUserDetial="currentRow" :timekey="timerModify"/>
    </div>
</template>

<script>
import api from '@/api/api';
import addUserDialog from './child/addUserDialog'
import modifyUserDialog from './child/modifyUserDialog'
import cxf from '@/utils/GeneralFn'
    export default {
        name: "userManage",
        components: {
            "addUserDialog": addUserDialog,
            "modifyUserDialog": modifyUserDialog
        },
        data() {
            return {
                tableData :[
                ],
                currentRow: [

                ],
                isAddUserShow:false,
                isModifyUserShow:false,
                timerAdd : 0,
                timerModify : 0,
                userListParam : {
                    PageNo:1,
                    PageSize:10,
                },
                totalPage:1,
                totalRows:1
            }
        },
        created(){
        },
        mounted(){
            this.getUserList ();
        },
        methods:{
            async getUserList () {
                const _resList = await api.postUserList( this.userListParam );
                if ( _resList.data.success ) {
                    const _tableList = _resList.data.data;
                    this.totalPage = _tableList.totalPage;
                    this.totalRows = _tableList.totalRows;
                    this.tableData = _tableList.rows;
                } else {
                    this.$message({
                        message: _resList.data.message,
                        type: 'warning'
                    });
                }
            },
            handleClickAddNew(){
                this.timerAdd = new Date().getTime();
                this.isAddUserShow = true;
            },
            handleUserStatus ( row ) {
                return cxf.handleUserStatus( row.user_status );
            },
            handleUserRole ( row ) {
                return cxf.handleUserRole( row.user_role );
            },
            hanldeCurrentPage( pageNum ){
                this.userListParam.PageNo = pageNum;
                this.getUserList();
            },
            deleteRow ( row ) {
                this.$confirm(
                    '你将要删除 用户['+row.user_account+'], 你确定需要这样做吗?',
                    'Warning',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }
                ).then( async () => {
                    const _res = await api.postDeleteUser( row );
                    if ( _res.data.data.success ) {
                        this.$message({
                            type: 'success',
                            message: '删除成功',
                        })
                    } else {
                        this.$message({
                            type: _res.data.data.message,
                            message: '删除失败',
                        })
                    }
                    
                }).catch(() => {})
            },
            modifyUserRow ( row ) {
                this.currentRow = row;
                this.timerModify = new Date().getTime();
                this.isModifyUserShow = true;
            }
        },
        watch:{
            isAddUserShow( nv ) {
                this.isAddUserShow = nv;
            },
            isModifyUserShow ( nv ) {
                this.isModifyUserShow = nv;
            }
        }
    }
</script>


<style>
.OperationBar {
    text-align:left;
    border-bottom:1px #ccc solid;
    padding:7px 15px;
}
</style>